// extracted by mini-css-extract-plugin
export var defaultWrapper = "_n0-3";
export var downloadButton = "_n0-4";
export var fileContainer = "_n0-9 _n0-7";
export var fileContainerBase = "_n0-7";
export var fileContainerFixedHeight = "_n0-8 _n0-7";
export var fileInfo = "_n0-5";
export var fileInfoWidthRestricted = "_n0-6";
export var fileType = "_n0-1";
export var fileTypeName = "_n0-2";
export var image = "_n0-0";
export var link = "_n0-b";
export var overflowEllipsis = "_n0-a";